export type TokenGetter = (options?: {
  template?: string
  skipCache?: boolean
}) => Promise<string | null>

export interface ClerkTokenProvider {
  getToken: TokenGetter
  userId: string | null | undefined
  sessionId: string | null | undefined
}

let provider: ClerkTokenProvider | null = null

export function setClerkTokenProvider(value: ClerkTokenProvider | null): void {
  provider = value
}

export function getClerkTokenProvider(): ClerkTokenProvider | null {
  return provider
}

export function getClerkTokenGetter(): TokenGetter | null {
  return provider?.getToken ?? null
}
